import { createStore } from 'vuex'

export default createStore({
  state: {
    windowWidth: document.documentElement.clientWidth,
    windowHeight: document.documentElement.clientHeight,
    user: '',
    currentContract: '',
    myChart: '',
    myChart2: '',
    myChart3: '',
    myBlock: 'all',
    myIndustry: 'all',
    searchData: '',
    chatData: '',
    signalData: '',
    trendData: '',
    marketData: '',
    blockData: '',
    basicData: '',
    returnData: '',
    financialData: '',
    technicalData: '',
    correlationData: '',
    regressionData: '',
    pickingData: '',
    meData: '',
  },
  mutations: {
    setWindowWidth(state, windowWidth) {
      state.windowWidth = windowWidth
    },
    setWindowHeight(state, windowHeight) {
      state.windowHeight = windowHeight
    },
    setUser(state, user) {
      state.user = user
    },
    setCurrentContract(state, currentContract) {
      state.currentContract = currentContract
    },
    setMyChart(state, myChart) {
      state.myChart = myChart
    },
    setMyChart2(state, myChart2) {
      state.myChart2 = myChart2
    },
    setMyChart3(state, myChart3) {
      state.myChart3 = myChart3
    },
    setSearchData(state, searchData) {
      state.searchData = searchData
    },
    setChatData(state, chatData) {
      state.chatData = chatData
    },
    setSignalData(state, signalData) {
      state.signalData = signalData
    },
    setTrendData(state, trendData) {
      state.trendData = trendData
    },
    setMarketData(state, marketData) {
      state.marketData = marketData
    },
    setBlockData(state, blockData) {
      state.blockData = blockData
    },
    setBasicData(state, basicData) {
      state.basicData = basicData
    },
    setReturnData(state, returnData) {
      state.returnData = returnData
    },
    setFinancialData(state, financialData) {
      state.financialData = financialData
    },
    setTechnicalData(state, technicalData) {
      state.technicalData = technicalData
    },
    setCorrelationData(state, correlationData) {
      state.correlationData = correlationData
    },
    setRegressionData(state, regressionData) {
      state.regressionData = regressionData
    },
    setPickingData(state, pickingData) {
      state.pickingData = pickingData
    },
    setMeData(state, meData) {
      state.meData = meData
    },
  },
  actions: {
  },
  modules: {
  }
})
